import React from 'react';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import { Box } from 'grommet';
import Callout from 'app/components/BookElements/Callout';

import LayoutEngine from 'app/api/layoutEngine';
const layoutEngine = new LayoutEngine({
  critical: Callout,
  warning: Callout,
  ok: Callout,
  info: Callout,
  unknown: Callout,
  disabled: Callout,
  halt: Callout,
});

function compileLayoutData(path, content) {
  let data = [];
  if (_.isArray(content)) {
    _.map(content, (content, index) => {
      if (_.isString(content)) {
        data.push({ type: 'paragraph', path: [...path, index] });
      } else {
        data.push({
          type: _.keys(content)[0].split(' ')[0],
          path: [...path, index, _.keys(content)[0]],
        });
      }
    });
  } else {
    if (_.isString(content)) {
      data.push({ type: 'paragraph', path });
    } else {
      data.push({
        type: _.keys(content)[0].split(' ')[0],
        path: [...path, _.keys(content)[0]],
      });
    }
  }
  return data;
}

function ListItem({ AppState, path, content }) {
  return (
    <Box
      aria-label="list item"
      border={_.last(path) === 0 ? 'horizontal' : 'bottom'}
      flex="grow"
      margin={{ horizontal: 'medium' }}
    >
      {compileLayoutData(path, content).map(data => layoutEngine.render(data))}
    </Box>
  );
}

export default inject('AppState')(observer(ListItem));



// WEBPACK FOOTER //
// ./src/app/components/BookElements/ListItem.js